<div class="t4translations">
    @if(selectedTranslationField) {
    <mat-form-field appearance="outline" class="translation-field" [ngStyle]="minWidthPx && minWidthPx > 0 ? {'min-width.px': minWidthPx} : {}">
      <input type="text" matInput [(ngModel)]="selectedTranslationField.Value" (ngModelChange)="onValueChanged()" placeholder="{{ placeholderMessage }}" [disabled]="!canEditTranslation" />
      @if(isTranslationView) {
      <mat-checkbox matSuffix [(ngModel)]="selectedTranslationField.IsVerified" (change)="onCheckboxToggled()" [disabled]="!canEditTranslation" class="is-verified-checkbox" [disableRipple]="true" [matTooltip]="selectedTranslationField.IsVerified ? ('Turbo.CustomerService.TranslationEditor.Verified' | translate : 'Verified') : ('Turbo.CustomerService.TranslationEditor.Unverified' | translate : 'Unverified')"></mat-checkbox>
      }
    </mat-form-field>
    }
  <mat-form-field appearance="outline" class="translation-dropdown">
    <mat-select [(value)]="selectedLanguage" [disabled]="!canEditTranslation" (selectionChange)="setSelectedLanguageValue()">
      <mat-select-trigger>
        @if(getSelectedLanguage()){
        <img [src]="getSelectedLanguage()?.T4FlagUrl" width="20" height="20" class="img-flag" />
        }
      </mat-select-trigger>
      @for(lang of filteredLanguages; track lang.Code){
      <mat-option [value]="lang.Code">
        <img [src]="lang.T4FlagUrl" width="20" height="20" class="img-flag" />
      </mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>
